import dayjs from 'dayjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptorParams } from '@app/core/interceptors/classes/http-interceptor-params';
import { TranslationObject } from '@ngx-translate/core';
import { environment } from '@environment';

@Injectable({
  providedIn: 'root',
})
export class I18nApiService {
  constructor(private readonly httpClient: HttpClient) {}

  public getDefaultLocalTranslate(): Observable<TranslationObject> {
    const url = `/locale/default.json?date=${dayjs().valueOf()}`; // prevent caching data

    return this.httpClient.get<TranslationObject>(url, {
      params: new HttpInterceptorParams({ toIgnoreAll: true, toIgnoreNavigationCancellation: true }),
    });
  }

  public getTranslationObjectFromServer(lang: string): Observable<TranslationObject> {
    const url = `${environment.apiBaseUrl}/v1/i18n/${lang}.json?date=${dayjs().valueOf()}`; // prevent caching data

    return this.httpClient.get<TranslationObject>(url, {
      params: new HttpInterceptorParams({ toIgnoreAll: true, toIgnoreNavigationCancellation: true }),
    });
  }
}
